<template>
  <div :key="pageSkeletonKey" :class="`wishlist-skeleton ${type}-skeleton padding-top-m padding-bottom-xl`">
    <div class="grid-x">
      <!-- Breadcrumb -->
      <AtomicUiSkeleton height="18px" width="252px" />
    </div>
    <!-- Header Section -->
    <div class="grid-x margin-top-xs align-justify" :style="containerStyle">
      <!-- Header -->
      <div class="grid-x" :style="containerStyle">
        <!-- Title -->
        <AtomicUiSkeleton height="30px" width="249px" />
        <!-- Details -->
        <div class="grid-x align-bottom" :style="containerStyle">
          <!-- Items Count -->
          <AtomicUiSkeleton height="30px" width="26px" />
          <!-- Default Status -->
          <AtomicUiSkeleton height="30px" width="52px" />
        </div>
      </div>
      <!-- Actions -->
      <div v-if="type === 'specific'" class="grid-x" :style="containerStyle">
        <!-- Share -->
        <AtomicUiSkeleton height="30px" width="64px" />
        <div :style="separatorStyle"></div>
        <!-- Settings -->
        <AtomicUiSkeleton height="30px" width="64px" />
        <template v-if="brand === 'mcom'">
          <div :style="separatorStyle"></div>
          <!-- Alerts -->
          <AtomicUiSkeleton height="30px" width="64px" />
          <!-- Tooltip -->
          <AtomicUiSkeleton height="30px" width="20px" />
          <!-- Toogle -->
          <AtomicUiSkeleton height="30px" width="81px" />
        </template>
      </div>
    </div>
    <!-- CTA Section -->
    <div v-if="type === 'guest'" class="grid-x margin-top-m">
      <AtomicUiSkeleton height="170px" width="100%" />
    </div>
    <!-- Filters (Common) -->
    <SkeletonWishlistFilters />
    <!-- Items Grid (Common) -->
    <div :key="`${type}-items-grid`" class="margin-top-l">
      <SkeletonProductGrid />
    </div>
  </div>
</template>

<script setup>
import { brand } from 'config';

const pageSkeletonKey = ref(1);

defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => ['guest', 'specific'].includes(value),
  },
});

onMounted(() => {
  pageSkeletonKey.value += 1;
});

const containerStyle = {
  'row-gap': 'var(--header-row-gap, 8px)',
  'column-gap': 'var(--header-column-gap, 8px)',
};

const separatorStyle = {
  height: 'var(--separator-height, 30px)',
  width: 'var(--separator-width, 1px)',
  backgroundColor: 'var(--gray-4-color, #d6d6d6)',
};
</script>

<style lang="scss" scoped>
.wishlist-skeleton {
  --gray-4-color: #{$gray-4-color};
  --separator-height: #{rem-calc(30px)};
  --separator-width: #{rem-calc(1px)};
  --header-row-gap: #{rem-calc(8px)};
  --header-column-gap: #{rem-calc(8px)};
  --actions-column-gap: #{rem-calc(12px)};
}
</style>
